import React from "react";
import classNames from "classnames/bind";
import styles from "./MiddleBorder.module.scss";
const cx = classNames.bind(styles);
export const MiddleBoder = () => <div className={cx("total-price")}></div>;
